import { Field } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  margin: ${(props) => (props.margin ? props.margin : '10px 0 10px 0')};
`;
export const Label = styled.label`
  margin-left: 10px;
`;
export const Input = styled(Field)`
  margin: 0 0 5px 0;
  padding-bottom: 5px;
  cursor: pointer;
`;

// customize o componente input com o tipo checkbox para ter um cursor pointer
